import { groupApps } from './groupApps';

const flattenTopLevelApps = (groups) => {
	if (!Array.isArray(groups)) {
		return [];
	}
	return groups.reduce((result, group) => {
		if (Array.isArray(group.apps)) {
			result.push(...group.apps);
		}
		return result;
	}, []);
};

const navigationsHome = flattenTopLevelApps(groupApps);

export { navigationsHome };
